import HomePage from '@/app/features/base/pages/HomePage.vue';
import { RouteRecordRaw } from 'vue-router';

let baseMountPath = '/';

const adminRoutes = [
  {
    path: `${baseMountPath}`,
    name: 'base-home',
    component: HomePage,
    meta: {
      requiresAuth: true,
    },
  },
];

const getBaseRoutes = (path = '/'): Array<RouteRecordRaw> => {
  baseMountPath = path;
  return adminRoutes;
};

export { getBaseRoutes };
